import React, { useCallback, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import rootStore from '../../../store/RootStore'

// import { LayoutContext } from '../../ui/Layout/Layout'
import { Circle, HStack, Spacer, Text, VStack } from '@chakra-ui/react'
import CustomCheckbox from '../../ui/CustomCheckbox'
// import { BiMessageDetail } from 'react-icons/bi'
import MoreMenu from '../../ui/MoreMenu'
import { getChartActions } from '../../../utils/ChartHelper'
import { ReportContext } from '../../../contexts/ReportContext'
import { observer } from 'mobx-react'

const ChartHeader = observer(
  ({
    title,
    subHeader,
    id,
    chartComponentRef,
    // numberOfComments = 0
  }) => {
    const {
      reportStore: { setDownloadSelection, filterOptionsSelected },
      chartStore: { charts },
    } = rootStore

    const filters = [
      ...filterOptionsSelected.values(),
    ].map(filter => filter.label)

    const { isDownloadOpen } = useContext(ReportContext)

    // const { onToggleRightPanel, isRightPanelOpen } = useContext(LayoutContext)

    // const handleCommentButtonClick = useCallback(() => {
    //   setChartId(id)
    //   setChartName(title)
    //   setCommentsDrawerVisible(true)
    //
    //   if (id && !isRightPanelOpen) {
    //     onToggleRightPanel(true)
    //   }
    // }, [
    //   setChartName,
    //   title,
    //   setChartId,
    //   id,
    //   setCommentsDrawerVisible,
    //   isRightPanelOpen,
    //   onToggleRightPanel,
    // ])

    const handleChangeDownloadCheckbox = useCallback(() => {
      setDownloadSelection(id)
    }, [id, setDownloadSelection])

    return (
      <VStack
        align="start"
        pb="16px">
        <HStack w="100%">
          {isDownloadOpen ? (
            <CustomCheckbox onChange={handleChangeDownloadCheckbox}>
              <Text textStyle="chartTitle">{title}</Text>
            </CustomCheckbox>
          ) : (
            <Text textStyle="chartTitle">{title}</Text>
          )}
          <Spacer />
          {/*<HStack>*/}
          {/*  <Box*/}
          {/*    key="1"*/}
          {/*    position="relative">*/}
          {/*    <IconButton*/}
          {/*      aria-label="Toggle Comments"*/}
          {/*      pt="3px"*/}
          {/*      backgroundColor="transparent"*/}
          {/*      icon={<BiMessageDetail size={32} />}*/}
          {/*      onClick={handleCommentButtonClick}*/}
          {/*      isActive={currentChartComment}*/}
          {/*    />*/}
          {/*    {numberOfComments > 0 && <NotificationIndicator />}*/}
          {/*  </Box>*/}
          {/*</HStack>*/}
          <ContextMenu
            caption={charts[id]?.caption || {}}
            filters={filters}
            title={title}
            id={id}
            chartComponentRef={chartComponentRef.current}
          />
        </HStack>
        {subHeader && (
          <Text
            textStyle="chartSubHeader"
            color="gray.500">
            {subHeader}
          </Text>
        )}
      </VStack>
    )
  }
)

const ContextMenu = React.memo(
  ({ chartComponentRef, title, caption, id, filters }) => {
    const actions = useMemo(
      () =>
        getChartActions({
          chartElement: chartComponentRef,
          title,
          caption,
          filters,
          id,
        }),
      [caption, chartComponentRef, filters, id, title]
    )
    return (
      <MoreMenu
        actions={actions}
        iconSize={32}
        onClick={e => e.stopPropagation()}
      />
    )
  }
)

const NotificationIndicator = () => (
  <Circle
    bg="brand.orange"
    size={3}
    position="absolute"
    right={0}
    top={1}
  />
)

NotificationIndicator.displayName = 'NotificationIndicator'

ChartHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
  id: PropTypes.string.isRequired,
  currentChartComment: PropTypes.any,
  chartComponentRef: PropTypes.any,
  numberOfComments: PropTypes.number,
}

export default ChartHeader
